const isProd = process.env.NODE_ENV === 'production';

export function parseCorsOriginsFromEnv(): string[] {
    const raw = process.env.CORS_URL;
    if (!raw?.trim()) return [];
    return raw
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
}

export function resolveCorsAllowOrigin(requestOriginHeader?: string | null): string {
    const allowed = parseCorsOriginsFromEnv();
    if (requestOriginHeader && allowed.length && allowed.includes(requestOriginHeader)) {
        return requestOriginHeader;
    }
    if (!isProd) {
        const local = process.env.LOCAL_CORS?.trim();
        if (local) return local;
        if (allowed.length) return allowed[0];
        return '*';
    }
    if (!allowed.length) return '*';
    return allowed[0];
}

export function jsonResponse(body: string, status = 200, requestOriginHeader?: string | null) {
    return {
        statusCode: status,
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': resolveCorsAllowOrigin(requestOriginHeader),
            'Access-Control-Allow-Methods': 'POST, OPTIONS',
            'Access-Control-Allow-Headers': 'Content-Type, Authorization',
        },
        body,
    };
}

export function devLog(...args: unknown[]): void {
    if (!isProd) console.log(...args);
}

export function devError(...args: unknown[]): void {
    if (!isProd) console.error(...args);
}

export function prodError(...args: unknown[]): void {
    console.error(...args);
}
